import React from 'react';

import Product from './Product';
import './Products.css';

const products = props => {
  return (
    <div
      className={props.checkout ? 'list-items cart-open' : 'list-items'}
      tabIndex={0}
      aria-label="Order items, select products"
      id="orders-items"
    >
      {props.products.map(product => (
        <Product
          isPopularDish={props.isPopularDish}
          key={product.id}
          product={product}
          business={props.business}
          selectProduct={props.selectProduct}
        />
      ))}
      <div className="cart-menu-category-overlay"></div>
    </div>
  );
};

export default products;



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Products/Products.js